import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';
import {BellOutlined, LogoutOutlined, MenuOutlined} from '@ant-design/icons';
import {Button, Dropdown, Grid, Input, MenuProps, Space, theme} from 'antd';
import {Header} from 'antd/es/layout/layout';
import {ReactComponent as Logo} from 'assets/images/logo.svg';
import {PRMGAvatar} from 'components/PRMGAvatar';
import {getIsMobile} from 'helpers/utils';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';
import {MobileMenu} from './MobileMenu';

enum LogoSize {
  DEFAULT = 395,
  SMALL = 250,
}

export const Topbar: React.FC = observer(() => {
  const {t} = useTranslation();
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const screen = Grid.useBreakpoint();
  const {token} = theme.useToken();

  const isMobile = React.useMemo(() => getIsMobile(screen), [screen]);

  const menuItems: MenuProps['items'] = React.useMemo(
    () => [
      {
        key: 'logout',
        label: (
          <Button type="ghost" icon={<LogoutOutlined />} style={{padding: 0}} onClick={() => appState.logout()}>
            {t('Log out')}
          </Button>
        ),
      },
    ],
    [t]
  );

  return (
    <>
      <Header
        className="sticky top-0 w-full z-10 flex items-center justify-between shadow-sm"
        style={{
          lineHeight: 0,
          background: token.colorBgBase,
          boxShadow: token.boxShadow,
          padding: isMobile ? token.paddingSM : token.paddingMD,
        }}
      >
        <NavLink to={AppRoutePaths.dashboard.url}>
          <Logo width={isMobile ? LogoSize.SMALL : LogoSize.DEFAULT} />
        </NavLink>
        <div style={{display: 'flex'}}>
          <Space>
            {isMobile ? (
              <Button icon={<MenuOutlined />} onClick={() => setOpenDrawer(true)} />
            ) : (
              <>
                <Button onClick={() => (document.location.href = '/protocol/protocol-menu')}>
                  Acceptance protocol
                </Button>
                <Input.Search placeholder={t('Search')} />
                <Button shape="circle" icon={<BellOutlined />} />
                <Dropdown menu={{items: menuItems}} placement="bottomRight">
                  <Button shape="circle" type="ghost" className="p-0 borber-0">
                    <PRMGAvatar />
                  </Button>
                </Dropdown>
              </>
            )}
          </Space>
        </div>
      </Header>
      <MobileMenu open={openDrawer} setOpen={setOpenDrawer} />
    </>
  );
});
